import { gql } from '@apollo/client';

export const CREATE_SURFACE_WEATHER_STATION = gql`
    mutation CreateSurfaceWeatherStation($input: CreateSurfaceWeatherStation!) {
        facility {
            process {
                createSurfaceWeatherStation(input: $input) {
                    id
                }
            }
        }
    }
`;
